import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type RemoveEhsrFromRrmDialogProps = {
  isOpen: boolean
  ehsrLabel: string | null
  onClose: () => void
  onConfirm: () => void
  isRemoving: boolean
}

export function RemoveEhsrFromRrmDialog({
  isOpen,
  ehsrLabel,
  onClose,
  onConfirm,
  isRemoving,
}: RemoveEhsrFromRrmDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className='sm:max-w-md' showCloseButton={!isRemoving}>
        <DialogHeader>
          <DialogTitle>
            {t(
              'riskReductionMeasuresLibraryPage.rrmDetail.removeEhsrDialog.title'
            )}
          </DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>
          {t(
            'riskReductionMeasuresLibraryPage.rrmDetail.removeEhsrDialog.message',
            { ehsr: ehsrLabel ?? '' }
          )}
        </p>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isRemoving}>
            {t('common:actions.cancel')}
          </Button>
          <Button
            variant='destructive'
            onClick={onConfirm}
            disabled={isRemoving}
          >
            {isRemoving
              ? t(
                  'riskReductionMeasuresLibraryPage.rrmDetail.removeEhsrDialog.removing'
                )
              : t(
                  'riskReductionMeasuresLibraryPage.rrmDetail.removeEhsrDialog.confirm'
                )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
